class KlaviyoBackInStock extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
  }

  connectedCallback() {
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit);
    }
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onFormSubmit);
  }

  removeMessage() {
    this.querySelector('[data-message-success]').classList.add('hidden');
    this.querySelector('[data-message-error]').classList.add('hidden');
  }

  setLoadingState(isLoading) {
    this.submitButton.classList.toggle('loading', isLoading);
    const spinner = this.submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  async onFormSubmit(event) {
    event.preventDefault();
    this.removeMessage();
    this.setLoadingState(true);
    const formData = new FormData(event.target);

    const backInStockSubscription = async () => {
      return fetch(event.target.getAttribute('action'), {
        method: event.target.getAttribute('method'),
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  id: `$shopify:::$default:::${formData.get('variant')}`,
                  type: 'catalog-variant',
                },
              },
            },
          },
        }),
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Revision: '2024-07-15',
        },
      });
    };

    const newsletterSubscription = async () => {
      if (formData.get('subscribe_for_newsletter') === 'on') {
        return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${formData.get('a')}`, {
          method: 'POST',
          body: JSON.stringify({
            data: {
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: formData.get('email'),
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    id: formData.get('g'),
                    type: 'list',
                  },
                },
              },
              type: 'subscription',
            },
          }),
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            Revision: '2024-07-15',
          },
        });
      } else {
        // Resolve immediately if newsletter subscription is not needed
        return Promise.resolve({ status: 200 });
      }
    };

    try {
      // Execute all fetch calls concurrently
      const results = await Promise.all([backInStockSubscription(), newsletterSubscription()]);

      // Check if all fetch calls were successful
      if (!results.every((res) => res.status === 200 || res.status === 202)) {
        throw new Error('One or more API calls failed to complete successfully');
      }

      this.querySelector('[data-message-success]').classList.remove('hidden');
    } catch (err) {
      console.error(err);
      this.querySelector('[data-message-error]').classList.remove('hidden');
    } finally {
      this.setLoadingState(false);
    }
  }
}
customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);
